"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var amber_1 = require("./amber");

var blue_1 = require("./blue");

var blueGrey_1 = require("./blueGrey");

var brown_1 = require("./brown");

var cyan_1 = require("./cyan");

var deepOrange_1 = require("./deepOrange");

var deepPurple_1 = require("./deepPurple");

var green_1 = require("./green");

var grey_1 = require("./grey");

var indigo_1 = require("./indigo");

var lightBlue_1 = require("./lightBlue");

var lightGreen_1 = require("./lightGreen");

var lime_1 = require("./lime");

var orange_1 = require("./orange");

var pink_1 = require("./pink");

var purple_1 = require("./purple");

var red_1 = require("./red");

var teal_1 = require("./teal");

var yellow_1 = require("./yellow");

var collection = {
  amber: amber_1.default,
  blue: blue_1.default,
  blueGrey: blueGrey_1.default,
  brown: brown_1.default,
  cyan: cyan_1.default,
  deepOrange: deepOrange_1.default,
  deepPurple: deepPurple_1.default,
  green: green_1.default,
  grey: grey_1.default,
  indigo: indigo_1.default,
  lightBlue: lightBlue_1.default,
  lightGreen: lightGreen_1.default,
  lime: lime_1.default,
  orange: orange_1.default,
  pink: pink_1.default,
  purple: purple_1.default,
  red: red_1.default,
  teal: teal_1.default,
  yellow: yellow_1.default
};
exports.default = collection;